<template>
  <div
    id="$address-book$"
    class="width-full height-full bg-F6F6F6 bt address-book"
  >
    <common-tag-filter
      :campusId="campusId"
      :address-type="addressType"
      :init-tags="initTags"
      :show.sync="showFilter"
      v-show="showFilter"
      @confirm="handleFilter"
    ></common-tag-filter>
    <!-- 查看详情 -->
    <div v-if="showSelectDetail" class="width-full height-full fb fb-col">
      <div
        class="item-flex-1 scroll pt-12 pb-60 bg-FFFFFF"
        refs="scroller"
        @scroll="handlerToGetNext"
      >
        <div
          v-for="(item, index) in selectedStudent"
          :key="item.studentDingId"
          class="pl-16"
          :class="{
            'mt-12':
              index > 0 &&
              item.classDingName !== selectedStudent[index - 1].classDingName,
            'mb-12': index === selectedStudent.length - 1
          }"
        >
          <div
            class="width-full c-191F25-56 lh-20 font-24"
            v-show="
              index > 0
                ? item.classDingName !==
                  selectedStudent[index - 1].classDingName
                : true
            "
            >{{ item.classDingName }}</div
          >
          <div class="bg-FFFFFF fb fb-main-start fb-cross-center">
            <div
              class="item-flex-1 height-full fb fb-main-between fb-cross-center"
              :class="{
                bt:
                  index > 0 &&
                  item.classDingName ===
                    selectedStudent[index - 1].classDingName
              }"
            >
              <div class="item-flex-1">
                <studentHead
                  :student-info="item"
                  :show-padding-right="false"
                  show-all-class
                  max-width="300"
                ></studentHead>
              </div>
              <i
                class="iconfont font-40 c-171A1D-40 mr-16"
                @click="clearStudent(item)"
                >&#xe670;</i
              >
            </div>
          </div>
        </div>
      </div>
      <div class="footer fixed bottom-0 fb fb-main-center fb-cross-center">
        <common-button @click="clearData" type="add" class="mr-16"
          >清空</common-button
        >
        <common-button type="primary" @click="confirmDetail"
          >确定</common-button
        >
      </div>
    </div>
    <!-- 通讯录页面 -->
    <div v-else class="width-full height-full fb fb-col">
      <div class="fb fb-row fb-cross-center fb-main-between bg-FFFFFF">
        <!-- 成员搜索输入框 -->
        <common-search-input-box
          class="p-8-0 p-0-8 bg-FFFFFF"
          placeholder="搜索学生姓名"
          :delay="1000"
          :searchValue="searchKey"
          @search="handlerToSearchMembers"
          @focus="handlerToFocusSearch"
          @blur="isFocus = false"
        ></common-search-input-box>
        <!-- 筛选 -->
        <div
          :class="[
            'w-88 font-28 text-right pr-16',
            selectTagList.length || gender !== '' ? 'c-006AFE ' : ''
          ]"
          @click="handleShowFilter"
        >
          <i
            class="iconfont mr-4"
            :class="[selectTagList.length ? 'c-006AFE ' : '']"
            >&#xe6f4;</i
          >筛选
        </div>
      </div>

      <!-- 部门层级导航 -->
      <common-node-nav
        class="p-0-16"
        v-if="this.nodeNav.length > 0 && !this.searchKey"
        :nodeNav="nodeNav"
        @click="handlerBackToNode"
      ></common-node-nav>
      <!-- 全选 -->
      <div
        v-show="computedIsShowSelectAll"
        class="h-56 fb fb-row fb-start-center font-34 bg-FFFFFF p-0-16 mb-8"
      >
        <common-checkbox
          :class="{ 'c-171A1D-28': computedIsDisabledSelectAll }"
          :isChecked="!computedIsDisabledSelectAll && compuedIsSelectedAll"
          @click="handlerToChangeSelections"
          ><span class="ml-12">全选</span></common-checkbox
        >
      </div>
      <div class="item-flex-1 scroll">
        <!-- 搜索结果成员列表 -->
        <div v-show="searchKey" class="node-list h-full font-34">
          <div
            v-show="searchStudents.length === 0"
            class="mt-60 h-full c-171A1D-56 fb-col-center-center item-flex-1"
          >
            <i class="iconfont font-120 c-171A1D-28 mb-16">&#xe6fb;</i>
            <span class="font-26">没有符合搜索条件的记录</span>
          </div>
          <div
            class="fb fb-row fb-cross-center pl-16 bg-FFFFFF"
            @click="handlerChangeStudentSelected(student)"
            v-for="(student, index) in searchStudents"
            :key="index"
          >
            <div class="mr-12"
              ><span
                class="iconfont font-48"
                :class="
                  handlerIsStudentSelected(student.selectStatus)
                    ? 'c-006AFE'
                    : 'c-171A1D-24'
                "
                >{{
                  handlerIsStudentSelected(student.selectStatus)
                    ? '&#xe66e;'
                    : '&#xe66f;'
                }}</span
              ></div
            >
            <div class="item-flex-1 fb fb-row fb-cross-center">
              <studentHead
                :student-info="student"
                :show-padding-right="false"
                show-all-class
                show-line
                max-width="300"
              ></studentHead>
            </div>
          </div>
        </div>
        <!-- 子级部门列表、部门成员列表 -->
        <div
          v-show="
            !searchKey &&
            ((currentDepts && currentDepts.length) > 0 ||
              (currentStudents && currentStudents.length > 0))
          "
          class="node-list item-flex-1 bg-FFFFFF font-34"
        >
          <!-- 子级部门列表 -->
          <div
            v-for="node in currentDepts"
            class="fb-start-center h-56 lh-56 pl-16 hidden-x"
            :key="node.deptId"
          >
            <span
              class="mr-16"
              :class="[
                'iconfont font-48',
                !node.studentCnt
                  ? 'c-171A1D-12'
                  : node.studentCnt === node.selStudentCnt
                  ? 'c-006AFE'
                  : 'c-171A1D-40'
              ]"
              @click="handlerChangeClassSelected(node, !node.studentCnt)"
            >
              {{
                node.studentCnt && node.studentCnt === node.selStudentCnt
                  ? '&#xe66e;'
                  : '&#xe66f;'
              }}
            </span>
            <div
              class="bb item-flex-1 fb fb-cross-center fb-main-between pr-16 hidden-x"
            >
              <div
                class="item-flex-1 fb fb-cross-center hidden-x"
                @click="handlerChangeClassSelected(node, !node.studentCnt)"
                ><span
                  :class="[
                    'text-ellipsis inline-block w-adapt-60',
                    !node.studentCnt ? 'c-171A1D-28' : 'c-171A1D'
                  ]"
                  >{{ node.deptName }}</span
                ><span
                  :class="[
                    'ml-8',
                    node.studentCnt
                      ? node.selStudentCnt
                        ? 'c-006AFE'
                        : 'c-171A1D-40'
                      : 'c-171A1D-28'
                  ]"
                  v-show="node.studentCnt === node.selStudentCnt"
                  >({{ node.studentCnt }})</span
                >
                <span
                  v-show="node.studentCnt !== node.selStudentCnt"
                  :class="[
                    'ml-8',
                    node.studentCnt
                      ? node.selStudentCnt
                        ? 'c-006AFE'
                        : 'c-171A1D-40'
                      : 'c-171A1D-28'
                  ]"
                  >({{ node.selStudentCnt }}/{{ node.studentCnt }})</span
                ></div
              >
              <div class="c-006AFE font-34">
                <span
                  class="bl-12 pl-9"
                  v-if="
                    node.hasChildren || (+node.type === 3 && node.studentCnt)
                  "
                  @click.stop="handlerToGetSubNodes(node)"
                >
                  <i class="iconfont">&#xe714;</i>下级
                </span>
              </div>
            </div>
          </div>
          <!-- 部门成员列表 -->
          <div
            class="fb fb-row fb-cross-center pl-16"
            @click="handlerChangeStudentSelections(student)"
            v-for="(student, index) in currentStudents"
            :key="index"
          >
            <div class="mr-12"
              ><span
                class="iconfont font-48"
                :class="
                  handlerIsStudentSelected(student.selectStatus)
                    ? 'c-006AFE'
                    : 'c-171A1D-24'
                "
                >{{
                  handlerIsStudentSelected(student.selectStatus)
                    ? '&#xe66e;'
                    : '&#xe66f;'
                }}</span
              ></div
            >
            <div class="item-flex-1 fb fb-row fb-cross-center">
              <studentHead
                :student-info="student"
                show-all-class
                max-width="300"
                show-line
              ></studentHead>
            </div>
          </div>
        </div>
      </div>
      <div
        class="font-26 fb fb-cross-center fb-main-between h-60 bg-FFFFFF p-0-16 bt-8"
      >
        <div class="item-flex-1 c-006AFE" @click.stop="handlerViewDetail">
          已选择: {{ memberCount }}人
          <!-- &#xe692; -->
          <i v-show="memberCount" class="ml-8 c-006AFE iconfont font-38"
            >&#xe610;</i
          >
        </div>
        <div>
          <common-button
            type="primary"
            :styles="'font-24'"
            width="95"
            height="32"
            @click="handlerToSubmit"
            >确定</common-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api/addressbook'
import {
  commonSearchInputBox,
  commonNodeNav,
  commonButton,
  commonCheckbox,
  commonTagFilter
} from '@/components/commonAddressBook'
import { studentHead } from '@/components'
import {
  getItem,
  getLocalItem,
  setLeft,
  removeLeft,
  pushNullUrl
} from '@/utils/comUtils'
import {
  mcConfirm,
  mcShowPreloader,
  mcHidePreloader,
  mcToast
} from '@/utils/mcSdkUtils'

import {} from '@/utils/constUtils'

export default {
  components: {
    commonSearchInputBox,
    commonNodeNav,
    commonButton,
    commonCheckbox,
    commonTagFilter,
    studentHead
  },
  props: {},
  data() {
    return {
      nodeNav: [], // 导航栏部门节点对象数组
      currentDepts: [], // 当前展示部门节点列表
      currentStudents: [], // 当前展示成员节点列表
      // 成员搜索相关
      isFocus: false, // 搜索框是否聚焦
      searchKey: '', // 搜索学生姓名关键字
      searchStudents: [], // 当前搜索学生姓名列表
      showSelectDetail: false, // 展示选择详情
      selectedData: [], // 已选择的数据
      sandboxStatus: 1, // 1 正在初始化 2 沙箱已准备好 3 正在增加选项 4 正在清除选项 5 重置中（暂无此状态） 6 提交中 7 已坏掉（处理数据异常） 8 已关闭
      sandboxItvl: null, // 查询状态定时器
      parentId: '', // 父节点id
      classList: [], // 已选班级
      classIndex: 0, // 当前班级
      pageNum: 50, // 分页页码
      classParam: [], // 查人参数
      selectedStudent: [], // 已选学生列表
      clicking: false,
      clearStudentsList: [],
      parentDeptType: 0,
      selDeptDingIds: [],
      selStudentDingIds: [],
      isOperateSelect: 0, // 0 未操作 1: 部门 2: 学生
      clearConfirm: null,
      otherConfirm: null,
      showFilter: false,
      selectTagList: [],
      gender: '',
      initTags: {}
    }
  },
  computed: {
    cpCommonParam() {
      return {
        campusId: this.campusId,
        sandboxId: this.sandboxId
      }
    },
    cpCommonTagParam() {
      return {
        ...this.cpCommonParam,
        selectTagList: this.selectTagList,
        gender: this.gender
      }
    },
    // 计算是否展示全选
    computedIsShowSelectAll() {
      let _result = true
      // 显示搜索学生姓名 || 无部门无成员 || 选择成员时无可选成员 || 选择部门时无可选部门
      if (
        this.searchKey ||
        (this.currentStudents &&
          this.currentStudents.length === 0 &&
          this.currentDepts &&
          this.currentDepts.length === 0)
      ) {
        _result = false
      }
      return _result
    },
    // 计算禁用全选
    computedIsDisabledSelectAll() {
      let _result = false
      if (this.currentDepts && this.currentDepts.length) {
        let _tag = true
        this.currentDepts.forEach(item => {
          if (item.studentCnt) {
            _tag = false
          }
        })
        _tag && (_result = true)
      }
      return _result
    },
    // 计算全选是否勾选
    compuedIsSelectedAll() {
      let _isSelectAll = true
      if (this.currentDepts && this.currentDepts.length) {
        this.currentDepts.forEach(item => {
          if (item.studentCnt !== item.selStudentCnt) {
            _isSelectAll = false
          }
        })
      } else if (this.currentStudents && this.currentStudents.length) {
        this.currentStudents.forEach(item => {
          if (!this.handlerIsStudentSelected(item.selectStatus)) {
            _isSelectAll = false
          }
        })
      }
      return _isSelectAll
    }
  },
  watch: {
    selectTagList: {
      handler(val, oldVal) {
        this.initData()
        this.init(true)
      },
      deep: true
    }
  },
  beforeCreate() {},
  created() {
    pushNullUrl()
    setLeft(this.methodSetLeft)
  },
  beforeMount() {},
  mounted() {
    // 钉钉回退按钮监听拦截
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    clearInterval(this.sandboxItvl)
    removeLeft(this.methodSetLeft)
  },
  destroyed() {},
  methods: {
    //  初始化
    async init(isSelect) {
      this.getSandboxStatus()
        .then(res => {
          this.addressGetNodes(isSelect)
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
      this.methodInitNodeNav()
    },
    // 初始化数据
    initData() {
      this.parentId = '' // 父节点id
      this.parentDeptType = 0
      this.searchKey = ''
      this.searchStudents = []
    },
    // 搜索框聚焦
    async handlerToFocusSearch() {
      this.isFocus = true
      await this.addressChangeSelections()
    },
    // 搜索学生姓名
    async handlerToSearchMembers(searchKey) {
      await this.addressChangeSelections()
      this.searchKey = searchKey
      if (!searchKey) {
        if (this.currentDepts && this.currentDepts.length) {
          this.addressGetNodes()
        }
        if (this.currentStudents && this.currentStudents.length) {
          this.addressQueryClassStudents()
        }
        return
      }
      this.addressSearchStudents()
    },
    // 获取子部门/学生
    async handlerToGetSubNodes(node) {
      if (this.clicking) {
        return
      }
      this.clicking = true
      await this.addressChangeSelections()
      this.methodUpdateNodeNav(node)
      this.parentId = node.deptId
      this.parentDeptType = node.type
      if (+node.type === 3 && node.studentCnt) {
        await this.addressQueryClassStudents()
      } else {
        await this.addressGetNodes()
      }
      this.clicking = false
    },
    async handleShowFilter() {
      await this.addressChangeSelections()
      this.showFilter = true
    },
    handleFilter(tags) {
      this.initTags = tags
      this.showFilter = false
      this.selectTagList = []
      Object.keys(tags).forEach(key => {
        if (key === 'sex') {
          this.gender = tags[key]
        } else if (tags[key] || tags[key] === 0) {
          this.selectTagList.push({
            tagId: key,
            tagOptionId: tags[key]
          })
        }
      })
    },
    // 判断学生是否勾选
    handlerIsStudentSelected(type) {
      if (+type === 1 || +type === 3) {
        return true
      }
      return false
    },
    // 切换部门勾选状态
    async handlerChangeClassSelected(node, disabled) {
      if (disabled) {
        return
      }
      this.isOperateSelect = 1
      const _seltag = node.selStudentCnt === node.studentCnt
      const _unselect = node.studentCnt - node.selStudentCnt
      this.memberCount = _seltag
        ? this.memberCount - node.selStudentCnt
        : this.memberCount + _unselect
      node.selStudentCnt = _seltag ? 0 : node.studentCnt
      node.isOperate = true
    },
    // 切换学生节点勾选状态 --- 搜索
    async handlerChangeStudentSelected(node) {
      const _seltag = this.handlerIsStudentSelected(node.selectStatus)
      let _API = _seltag
        ? 'addressUnselectOneStudent'
        : 'addressSelectOneStudent'
      let _qAPI = this.searchKey
        ? 'addressSearchStudents'
        : 'addressQueryClassStudents'
      await this[_API](node.studentDingId)
      this[_qAPI]()
    },
    // 切换学生节点勾选状态
    async handlerChangeStudentSelections(node) {
      this.isOperateSelect = 2
      const _seltag = this.handlerIsStudentSelected(node.selectStatus)
      _seltag ? --this.memberCount : ++this.memberCount
      node.selectStatus = _seltag ? 4 : 3
    },
    // 获取勾选项
    getSelectedIds() {
      if (!this.isOperateSelect) {
        return
      }
      this.selDeptDingIds = []
      this.selStudentDingIds = []
      if (this.currentDepts && this.currentDepts.length) {
        this.selStudentDingIds = null
        this.currentDepts.forEach(item => {
          if (item.isOperate) {
            this.selDeptDingIds.push({
              deptDingId: item.deptId,
              selected: item.studentCnt === item.selStudentCnt
            })
          }
        })
      } else if (this.currentStudents && this.currentStudents.length) {
        this.selDeptDingIds = null
        this.currentStudents.forEach(item => {
          if (this.handlerIsStudentSelected(item.selectStatus)) {
            this.selStudentDingIds.push(item.studentDingId)
          }
        })
      }
    },
    // 全选操作
    async handlerToChangeSelections() {
      if (this.computedIsDisabledSelectAll) {
        return
      }
      let _isSelected = this.compuedIsSelectedAll
      let _memberCount = this.memberCount
      if (this.currentDepts && this.currentDepts.length) {
        this.isOperateSelect = 1
        this.currentDepts.forEach(item => {
          item.isOperate = true
          const _seltag = item.selStudentCnt === item.studentCnt
          const _unselect = item.studentCnt - item.selStudentCnt
          _isSelected && _seltag && (_memberCount -= item.selStudentCnt)
          !_isSelected && !_seltag && (_memberCount += _unselect)
          item.selStudentCnt = _isSelected ? 0 : item.studentCnt
        })
      } else if (this.currentStudents && this.currentStudents.length) {
        this.isOperateSelect = 2
        this.currentStudents.forEach(item => {
          const _seltag = this.handlerIsStudentSelected(item.selectStatus)
          _isSelected && _seltag && --_memberCount
          !_isSelected && !_seltag && ++_memberCount
          item.selectStatus = _isSelected ? 4 : 3
        })
      }
      this.memberCount = _memberCount
    },
    // 查看已选学生
    async handlerViewDetail() {
      if (!this.memberCount) {
        return
      }
      this.clearStudentsList = []
      await this.addressChangeSelections()
      this.selectedStudent = []
      await this.addressQuerySelectClasses()
      this.handlerGetClassPage()
      await this.addressQueryClassStudents(1)
      this.showSelectDetail = true
    },
    // 获取已选学生班级分页
    handlerGetClassPage() {
      let _num = 0
      this.classParam = []
      this.classList &&
        this.classList.length &&
        this.classList.some((item, index) => {
          if (_num >= this.pageNum) {
            return false
          }
          this.classIndex = index + 1
          _num += item.selStudentCnt
          this.classParam.push(item.classDingId)
        })
      this.classList.splice(0, this.classIndex)
    },
    // 加载已选学生下一页搜索结果
    async handlerToGetNext(e) {
      let _el = e.currentTarget
      if (!this.classList.length) return
      if (
        _el.scrollTop + _el.clientHeight >= _el.scrollHeight - 10 &&
        !this.isLoadDetailMore
      ) {
        this.isLoadDetailMore = true
        this.handlerGetClassPage()
        await this.addressQueryClassStudents(1)
      }
    },
    // 删除已选学生
    clearStudent(item) {
      this.clearStudentsList.push(item.studentDingId)
      this.selectedStudent.forEach((itm, index) => {
        if (itm.studentDingId === item.studentDingId) {
          this.selectedStudent.splice(index, 1)
        }
      })
    },
    // 查看已选 确认
    async confirmDetail() {
      if (this.clearStudentsList.length) {
        await this.addressUnslectStudents(this.clearStudentsList)
        this.getSandboxStatus()
          .then(res => {
            if (this.currentDepts && this.currentDepts.length) {
              this.addressGetNodes()
            }
            if (this.currentStudents && this.currentStudents.length) {
              this.addressQueryClassStudents()
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
      this.showSelectDetail = false
    },
    // 查看已选 清空
    clearData() {
      const that = this
      this.clearConfirm = this.$Dialog({
        type: 'confirm',
        title: '提示',
        content: `确认清空已选成员`,
        async onConfirm() {
          await that.addressUnslectAll()
          that.showSelectDetail = false
          that.initData()
          that.init()
        }
      }).show()
    },
    // 初始化导航栏
    methodInitNodeNav({ name, deptId = '' } = {}) {
      let _name =
        (getLocalItem(`CURRENT_CAPMUS_${getItem('TOKEN').orgId}`) || {}).name ||
        '通讯录'
      let _node = {
        deptName: name || _name,
        deptId: deptId,
        type: 0
      }
      this.nodeNav = [_node]
    },
    // 更新导航栏
    methodUpdateNodeNav(node, isAdd = true) {
      if (isAdd) {
        this.nodeNav.push(node)
      } else {
        let _index = this.nodeNav.findIndex(item => item.deptId === node.deptId)
        this.nodeNav = this.nodeNav.slice(0, _index + 1)
      }
    },
    // 返回导航栏
    async handlerBackToNode(node) {
      await this.addressChangeSelections()
      this.methodUpdateNodeNav(node, false)
      this.parentId = node.deptId
      this.parentDeptType = node.type
      this.addressGetNodes()
    },
    // 点击确认 关闭选人组件
    async handlerToSubmit() {
      if (this.clicking) {
        return
      }
      await this.addressChangeSelections()
      this.clicking = true
      if (this.checkMemberConflict) {
        this.addressGetChangeSummary()
          .then(async res => {
            // 人员已在其它考勤组中
            if (
              res &&
              res.conflictStudentNames &&
              res.conflictStudentNames.length
            ) {
              mcConfirm({
                msg: `${res.conflictStudentNames[0]}${
                  res.conflictCnt > 1 ? '等人' : ''
                }已存在其它${this.conflictText}组中，是否移动到当前${
                  this.conflictText
                }组`,
                title: '提示'
              })
                .then(async buttonIndex => {
                  if (buttonIndex) {
                    await this.addressCommitPreSelections()
                    let _result = {
                      memberCount: this.memberCount
                    }
                    if ((res.conflictStudentGroupIdList || []).length) {
                      _result.conflictStudentGroupIdList =
                        res.conflictStudentGroupIdList
                    }
                    this.clicking = false
                    this.close(_result)
                  } else {
                    this.clicking = false
                  }
                })
                .catch(err => {
                  console.log('unhandledrejection', err)
                })
            } else {
              // 没有冲突人员
              await this.addressCommitPreSelections()
              let _result = {
                memberCount: this.memberCount
              }
              this.close(_result)
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      } else {
        // 没有冲突人员
        await this.addressCommitPreSelections()
        let _result = {
          memberCount: this.memberCount
        }
        this.close(_result)
      }
    },
    // 回退拦截
    methodSetLeft() {
      pushNullUrl()
      if (this.showSelectDetail || this.showFilter) {
        this.clearConfirm && this.clearConfirm.hide()
        this.showSelectDetail = false
        this.showFilter = false
      } else {
        if (this.showConfirm) {
          return false
        }
        this.showConfirm = true
        mcConfirm({ msg: '确认退出此操作吗?', closeOnPopstate: false })
          .then(async btnIndex => {
            if (btnIndex === 1) {
              mcHidePreloader()
              await this.addressRollbackPreSelections()
              this.closeOnly()
            } else {
              this.showConfirm = false
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    // 创建选人组件沙盒API
    addressCreate() {
      return new Promise((resolve, reject) => {
        API.addressCreate({
          campusId: this.campusId,
          studentGroupId: this.studentGroupId,
          sandboxType: this.sandboxType
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            if (res) {
              this.$store.commit('sandboxId', res)
            }
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 轮训查状态API
    getSandboxStatus() {
      // 1 正在初始化 2 沙箱已准备好 3 正在增加选项 4 正在清除选项 5 重置中（暂无此状态） 6 提交中 7 提交失败，待重试 8 已坏掉
      this.sandboxStatus = 1
      let _itvlTimes = 0
      mcShowPreloader()
      clearInterval(this.sandboxItvl)
      return new Promise((resolve, reject) => {
        if (this.isSandboxComplete) {
          resolve(true)
        } else {
          this.sandboxItvl = setInterval(async () => {
            ++_itvlTimes
            if (_itvlTimes >= 20) {
              clearInterval(this.sandboxItvl)
              this.addressResetStatus()
              mcHidePreloader()
              mcToast({ msg: '操作超时，请重试～' })
            }
            switch (this.sandboxStatus) {
              case 2:
                this.isSandboxComplete = true
                clearInterval(this.sandboxItvl)
                resolve(this.sandboxStatus)
                break
              case 8:
                clearInterval(this.sandboxItvl)
                this.addressResetStatus()
                mcHidePreloader()
                mcToast({ msg: '操作超时，请重试～' })
                // await this.addressCreate()
                this.initData()
                this.init()
                break
              default:
                await this.addressGetStatus()
                break
            }
          }, 1000)
        }
      })
    },
    // 查询树准备情况API
    addressGetStatus() {
      return new Promise((resolve, reject) => {
        API.addressGetStatus({
          ...this.cpCommonParam
        })
          .then(res => {
            this.sandboxStatus = res.sandboxStatus || 0
            this.memberCount = res.selStudentCnt || 0
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查树节点信息API
    addressGetNodes(isSelect) {
      return new Promise((resolve, reject) => {
        API.addressGetNodes({
          parentDeptId: this.parentId,
          ...this.cpCommonTagParam
        })
          .then(res => {
            // type 校区: 0 学段: 1 年级: 2 班级: 3 部门: 4
            this.currentStudents = []
            this.currentDepts = res || []
            mcHidePreloader()
            resolve(res)
          })
          .catch(err => {
            mcHidePreloader()
            console.log(err)
          })
      })
    },
    // 加部门筛选条件（异步）API
    addressSelectDepts(deptIds) {
      return new Promise((resolve, reject) => {
        API.addressSelectDepts({
          deptDingIds: deptIds,
          ...this.cpCommonTagParam
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 移除部门筛选条件（异步）API
    addressUnselectDepts(deptIds) {
      return new Promise((resolve, reject) => {
        API.addressUnselectDepts({
          deptDingIds: deptIds,
          ...this.cpCommonTagParam
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 加已选学生（异步）API
    addressSelectStudents(studentDingIds) {
      return new Promise((resolve, reject) => {
        API.addressSelectStudents({
          studentDingIds: studentDingIds,
          ...this.cpCommonTagParam
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 勾选 API
    addressChangeSelections(useOldTag = false) {
      this.getSelectedIds()
      if (this.isOperateSelect === 1) {
        return new Promise((resolve, reject) => {
          const param = {
            deptSelectionChanges: this.selDeptDingIds,
            ...this.cpCommonTagParam
          }

          API.addressChangeDeptSelections(param)
            .then(res => {
              if ((res && res.result && res.result !== '0') || res === null) {
                return false
              }
              if (res === 0 || res) {
                this.isOperateSelect = 0
                this.memberCount = res
              }
              resolve(res)
            })
            .catch(err => {
              console.log(err)
            })
        })
      } else if (this.isOperateSelect === 2) {
        return new Promise((resolve, reject) => {
          const param = {
            classDingId: this.parentId,
            selStudentDingIds: this.selStudentDingIds,
            ...this.cpCommonTagParam
          }

          API.addressChangeClassStudentSelections(param)
            .then(res => {
              if ((res && res.result && res.result !== '0') || res === null) {
                return false
              }
              if (res === 0 || res) {
                this.isOperateSelect = 0
                this.memberCount = res
              }
              resolve(res)
            })
            .catch(err => {
              console.log(err)
            })
        })
      }
    },
    // 选中单个学生 API
    addressSelectOneStudent(studentDingId) {
      return new Promise((resolve, reject) => {
        API.addressSelectOneStudent({
          ...this.cpCommonParam,
          studentDingId: studentDingId
        })
          .then(res => {
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            if (res === 0 || res) {
              this.memberCount = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 取消选中单个学生 API
    addressUnselectOneStudent(studentDingId) {
      return new Promise((resolve, reject) => {
        API.addressUnselectOneStudent({
          ...this.cpCommonParam,
          studentDingId: studentDingId
        })
          .then(res => {
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            if (res === 0 || res) {
              this.memberCount = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 移除已选学生（异步）API
    addressUnslectStudents(studentDingIds) {
      return new Promise((resolve, reject) => {
        API.addressUnslectStudents({
          ...this.cpCommonParam,
          studentDingIds: studentDingIds
        })
          .then(res => {
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            if (res === 0 || res) {
              this.memberCount = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 清除所有已选择API
    addressUnslectAll() {
      return new Promise((resolve, reject) => {
        API.addressUnslectAll({
          ...this.cpCommonParam
        })
          .then(res => {
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            if (res === 0 || res) {
              this.memberCount = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查询已选学生列表-有选项的班级列表API
    addressQuerySelectClasses() {
      return new Promise((resolve, reject) => {
        API.addressQuerySelectClasses({
          ...this.cpCommonParam
        })
          .then(res => {
            let _res = res || []
            this.selectedStudent = []
            this.classList = _res
            resolve(_res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查询已选学生列表-学生列表API
    addressQueryClassStudents(isSelected) {
      return new Promise((resolve, reject) => {
        API.addressQueryClassStudents({
          ...this.cpCommonParam,
          classDingIds: isSelected ? this.classParam : [this.parentId],
          selectTagList: isSelected ? [] : this.selectTagList,
          gender: this.gender,
          selectStatus: isSelected ? [1, 3] : null,
          returnExtFields: [
            'accommodationTagName',
            'className',
            'gender',
            'dormName'
          ]
        })
          .then(res => {
            let _res = res || []
            if (isSelected) {
              this.selectedStudent = this.selectedStudent.concat(_res) || []
            } else {
              this.currentDepts = []
              this.currentStudents = _res
            }

            mcHidePreloader()
            resolve(_res)
          })
          .catch(err => {
            console.log(err)
            mcHidePreloader()
          })
          .finally(() => {
            this.isLoadDetailMore = false
          })
      })
    },
    // 搜索学生API
    addressSearchStudents() {
      return new Promise((resolve, reject) => {
        API.addressSearchStudents({
          ...this.cpCommonParam,
          limit: 20,
          q: this.searchKey
        })
          .then(res => {
            let _res = res || []
            this.searchStudents = _res
            mcHidePreloader()
            resolve(_res)
          })
          .catch(err => {
            console.log(err)
            mcHidePreloader()
          })
      })
    },
    // 提交预选项API
    addressCommitPreSelections() {
      return new Promise((resolve, reject) => {
        API.addressCommitPreSelections({
          ...this.cpCommonParam
        })
          .then(res => {
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            if (res === 0 || res) {
              this.memberCount = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 取消预选项
    addressRollbackPreSelections() {
      return new Promise((resolve, reject) => {
        API.addressRollbackPreSelections({
          ...this.cpCommonParam
        })
          .then(res => {
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            if (res === 0 || res) {
              this.memberCount = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查询沙盒变更概述
    addressGetChangeSummary() {
      return new Promise((resolve, reject) => {
        API.addressGetChangeSummary({
          ...this.cpCommonParam,
          returnConflictStudentNamesLimit: 1
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 重置沙箱
    addressResetStatus() {
      return new Promise((resolve, reject) => {
        API.addressResetStatus({
          ...this.cpCommonParam
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.address-book {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 22;
  overflow-y: scroll;
}

.node-list {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.tab-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 3px;
  background: #006afe;
  border-radius: 2px;
}
.head-img-text {
  height: 36px;
  width: 36px;
  color: #ffffff;
  margin-right: 12px;
  background: #006afe;
  border-radius: 50%;
}
.footer {
  :deep(.c-button) {
    height: 46px;
    line-height: 46px;
    border-radius: 8px;
  }
}
</style>
